import React, { useState } from "react";
import LeftSideBar from "./leftsidebar";
import Header from "./header";
import { useNavigate } from "react-router-dom";
import NotificationDrawer from "../../components/ui/NotificationDrawer";

export const Layout = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [isSidebarHovered, setIsSidebarHovered] = useState(false);
  const [isNotifOpen, setIsNotifOpen] = useState(false);
  const [hasUnread, setHasUnread] = useState(false);

  const drawerClick = () => {
    setOpen(!open);
  };
  const userRole = localStorage.getItem("userRole")?.trim();
  const navigate = useNavigate();
  return (
    <>
      <section className="main-area" style={{ flexDirection: 'column' }}>
        {userRole === "" && (
          <li
            className="nav-singl"
            title="Add RFP Data"
            onClick={() => navigate("/add-rfp-data")}
          >
            <a href="#">
              <img src="../images/add_program_field.svg" alt="icon" />{" "}
              <span>Add RFP Data</span>
            </a>
          </li>
        )}

        <Header
          drawerClick={drawerClick}
          open={open}
          isSidebarHovered={isSidebarHovered}
          hasUnread={hasUnread}
          onBellClick={() => setIsNotifOpen(true)}
        />

        <div className="content-wrapper" style={{ display: 'flex', width: '100%', marginTop: '60px' }}>
          {/* Only show LeftSideBar if userRole is NOT empty */}
          {userRole && (
            <LeftSideBar
              open={open}
              drawerClick={drawerClick}
              onHover={setIsSidebarHovered}
            />
          )}

          <div className="right-bar">
            {children}
          </div>
        </div>
      </section>

      {/* Global Notification Drawer — available on every page */}
      <NotificationDrawer
        isOpen={isNotifOpen}
        onClose={() => setIsNotifOpen(false)}
        onUnreadChange={setHasUnread}
      />
    </>
  );
};
